import { queries } from "@/graphql";
import { useQuery } from "@apollo/client/react";

export interface SettingKeyItem {
  id: string;
  key: string;
  type: string;
  createdBy?: string;
  updatedBy?: string;
  createdByName?: string;
  updatedByName?: string;
  createdAt?: string;
  updatedAt?: string;
}

export function useSettingKeys(type?: string) {
  const { data, loading, error, refetch } = useQuery<{
    settingKeys: SettingKeyItem[];
  }>(queries.settingKeys, {
    variables: type ? { type } : {},
    errorPolicy: "all",
  });

  return {
    settingKeys: data?.settingKeys || [],
    loading,
    error,
    refetch,
  };
}
